import styled from 'styled-components'
import { padding, PaddingProps } from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

export type ContainerProps = PaddingProps

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.section.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  ${padding}
`
